import { useLoaderData, useParams } from 'react-router-dom'
import {SlLocationPin} from 'react-icons/sl'
import {BiBusSchool} from 'react-icons/bi'
import {FaRegBuilding, FaRegUser} from 'react-icons/fa'
import {MdOutlinePhoneEnabled, MdMiscellaneousServices} from 'react-icons/md'
import schools from './schools'
export default function CareerDetails() {
  const { _id } = useParams()
  console.log("id is : ", _id)
  // const career = useLoaderData()
  const findSchool = _id => schools.find(school => school._id == _id);
  const school = (findSchool(_id))
  console.log("schools is : ", school)
  return (
    <div className="container career-details">
      <h2 className='text-center school-title'>
        <BiBusSchool  size={30} className='text-right '/>
        تفاصيل مدرسة  <span className='text-color-primary-light'>   {school.shem_beit_sefer} </span></h2>
      <div className='school-details'>
        <div className='flex-box'>
          <p className='flex-box'>
            <SlLocationPin  size={20} className=' icon '  />
            الموقع : {school.ktovet}
          </p>
          <p className='flex-box'>
          <FaRegBuilding  size={20} className=' icon '   />

            المدينة : {school.ezor}</p>
          <p className='flex-box'>
          <FaRegUser  size={20} className=' icon '  />
            اسم المدير : {school.menahel}</p>
          <p className='flex-box'>
          <MdOutlinePhoneEnabled  size={25} className=' icon '  />
             رقم الهاتف: <a className='link school-link' href={'tel:'+ school.telefon}> {school.telefon} </a></p>
        </div>
       <div className='school-services'>
       <p>
         <strong> <MdMiscellaneousServices className='icon' size={20} />
          الخدمات المتوفرة :</strong> </p>
        <ol className='flex-box no-space services  ' >
          {school.prati == 1 && <li> تعليم رخصة خصوصي </li>}
          {school.ofnoa == 1 && <li> تعليم رخصة دراجة هوائية  </li>}
          {school.grar == 1 && <li> تعليم رخصة مجرور  </li>}
          {school.masa == 1 && <li> تعليم رخصة شحن  </li>}
          {school.traktor == 1 && <li> تعليم رخصة تركتور</li>}
          {school.otobus == 1 && <li> تعليم رخصة باص </li>}
        </ol>

       </div>
      </div>
    </div>
  )
}

// data loader
// export const careerDetailsLoader = async ({ params }) => {
//   const { _id } = params

//   const res = await fetch('http://localhost:4000/careers/' + _id)

//   if (!res.ok) {
//     throw Error('Could not find that career.')
//   }

//   return res.json()
// }